import { render, staticRenderFns } from "./biz.vue?vue&type=template&id=01939328&"
import script from "./biz.vue?vue&type=script&lang=js&"
export * from "./biz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports